import { IconProps } from "@utils/types/components";

export const SettingsIcon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.516 18.537H8.094a.853.853 0 01-.593-.228.91.91 0 01-.297-.57l-.274-2.122a3.447 3.447 0 01-.558-.274 7.498 7.498 0 01-.514-.342l-1.984.821a1.02 1.02 0 01-.64.023.848.848 0 01-.501-.388l-1.688-2.942a.857.857 0 01-.114-.64.875.875 0 01.342-.547l1.71-1.3a2.18 2.18 0 01-.022-.308v-.616c0-.099.008-.201.023-.308l-1.711-1.3a.876.876 0 01-.342-.548.857.857 0 01.114-.638l1.688-2.943a.719.719 0 01.49-.4 1.12 1.12 0 01.65.035l1.985.821a6.22 6.22 0 01.525-.342c.182-.107.365-.198.547-.274l.274-2.121a.91.91 0 01.297-.57.853.853 0 01.593-.229h3.422c.228 0 .426.076.593.228a.91.91 0 01.296.57l.274 2.122c.198.076.384.167.56.274.174.106.345.22.512.342l1.985-.821c.213-.076.426-.084.639-.023.213.06.38.19.502.388l1.688 2.943c.121.197.16.41.114.638a.876.876 0 01-.342.548l-1.711 1.3c.015.107.023.21.023.308v.616c0 .099-.016.202-.046.308l1.71 1.3c.183.137.297.32.343.548a.857.857 0 01-.114.639l-1.688 2.92a.899.899 0 01-.513.4c-.22.067-.438.063-.65-.013l-1.94-.82a6.247 6.247 0 01-.524.341 4.597 4.597 0 01-.548.274l-.274 2.122a.91.91 0 01-.296.57.852.852 0 01-.593.228zM9.85 12.606c.883 0 1.635-.312 2.259-.935a3.077 3.077 0 00.935-2.259c0-.882-.312-1.635-.935-2.258a3.077 3.077 0 00-2.259-.936c-.897 0-1.654.312-2.27.936a3.097 3.097 0 00-.923 2.258c0 .882.308 1.635.923 2.258.616.624 1.373.936 2.27.936z"
        fill={color}
      />
    </svg>
  );
};
